import { render } from "./AdminUserAddresses.vue?vue&type=template&id=0b226028&scoped=true"
import script from "./AdminUserAddresses.vue?vue&type=script&lang=js"
export * from "./AdminUserAddresses.vue?vue&type=script&lang=js"

import "./AdminUserAddresses.vue?vue&type=style&index=0&id=0b226028&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b226028"]])

export default __exports__